import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import {FC} from "react";
import {useNavigate} from "react-router-dom";




interface IButtonAppBarProps {
}


const ButtonAppBar: FC<IButtonAppBarProps> = () => {

    const navigate = useNavigate();

    const isLoggedIn = (): boolean  => {
        let token = localStorage.getItem("token");
        if (!token) {
            return false
        }
        return true
    }
    const handleDocumentation = () => {
        window.open('https://doc-wscu.dance4water.org', "_blank")
    }
    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        navigate('/')
    }
    const handleLogin = () => {
        navigate('/')
    }

    return (
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1}} >
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        WSCA Tool and User management
                    </Typography>
                    {!isLoggedIn() &&
                        <Button color="inherit" onClick={handleLogin} >Login</Button>
                    }
                    {isLoggedIn() &&
                        <Button color="inherit" onClick={handleLogout}>Logout</Button>
                    }
                     <Button color="inherit" onClick={handleDocumentation}>Documentation</Button>
                </Toolbar>
            </AppBar>
        );
}


export default ButtonAppBar;
